import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpinner = ({ 
  tip = "Chargement en cours...", 
  fullScreen = true,
  overlay = false,
  children
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 40, color: '#fdd119' }} spin />;
  const spinner = (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
      <Spin 
        indicator={antIcon}
        size="large"
        className="global-spinner"
      />
      {tip && <div style={{ color: '#666', fontSize: 14 }}>{tip}</div>}
    </div>
  );

  if (overlay && children) {
    return (
      <div className="global-loading-overlay">
        {children}
        <div className="global-loading-overlay-content">
          {spinner}
        </div>
      </div>
    );
  }

  return (
    <div className={`global-loading-container ${fullScreen ? 'full-screen' : ''}`}>
      {spinner}
    </div>
  );
};

export default LoadingSpinner;